import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 避免点击重复路由报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/base-login',
        name: 'BaseLogin',
        component: () => import(/* webpackChunkName: "base-login" */ '../views/BaseLogin/BaseLogin.vue')
    },
    {
        path: '/base-quick',
        name: 'BaseQuick',
        component: () => import(/* webpackChunkName: "base-quick" */ '../views/BaseQuick/BaseQuick.vue')
    },
    {
        path: '/base-register',
        name: 'BaseRegister',
        component: () => import(/* webpackChunkName: "base-register" */ '../views/BaseRegister/BaseRegister.vue')
    },
    {
        path: '/base-agree',
        name: 'BaseAgree',
        component: () => import(/* webpackChunkName: "base-agree" */ '../views/BaseRegister/BaseAgree.vue')
    },
    {
        path: '/base-forget-pwd',
        name: 'BaseForgetPwd',
        component: () => import(/* webpackChunkName: "base-forget-pwd" */ '../views/BaseForgetPwd/BaseForgetPwd.vue')
    },
    {
        path: '/base-realname',
        name: 'BaseRealname',
        component: () => import(/* webpackChunkName: "base-realname" */ '../views/BaseRealname/BaseRealname.vue')
    },
    {
        path: '/base-wallow',
        name: 'BaseWallow',
        component: () => import(/* webpackChunkName: "base-wallow" */ '../views/BaseWallow/BaseWallow.vue')
    },
    {
        path: '/base-visitor',
        name: 'BaseVisitor',
        component: () => import(/* webpackChunkName: "base-visitor" */ '../views/BaseVisitor/BaseVisitor.vue')
    },
    {
        path: '/base-trumpet-select',
        name: 'BaseTrumpetSelect',
        component: () => import(/* webpackChunkName: "base-trumpet-select" */ '../views/BaseTrumpetSelect/BaseTrumpetSelect.vue')
    },
    {
        path: '/base-trumpet-explain',
        name: 'BaseTrumpetExplain',
        component: () => import(/* webpackChunkName: "base-trumpet-explain" */ '../views/BaseTrumpetExplain/BaseTrumpetExplain.vue')
    },
    {
        path: '/base-trumpet-add',
        name: 'BaseTrumpetAdd',
        component: () => import(/* webpackChunkName: "base-trumpet-add" */ '../views/BaseTrumpetAdd/BaseTrumpetAdd.vue')
    },
    {
        path: '/base-yx-pay',
        name: 'BaseYxPay',
        component: () => import(/* webpackChunkName: "base-yx-pay" */ '../views/BaseYxPay/BaseYxPay.vue')
    },
    {
        path: '/base-yx-voucher',
        name: 'BaseYxVoucher',
        component: () => import(/* webpackChunkName: "base-yx-voucher" */ '../views/BaseYxPay/BaseYxVoucher.vue')
    },
    {
        path: '/base-pay-success',
        name: 'BasePaySuccess',
        component: () => import(/* webpackChunkName: "base-pay-success" */ '../views/BasePaySuccess/BasePaySuccess.vue')
    },
    {
        path: '/',
        name: 'index',
        component: () => import(/* webpackChunkName: "index" */ '../views/index.vue'),
        redirect: '/user',
        children: [
            {
                path: '/user',
                name: 'BaseAccount',
                component: () => import(/* webpackChunkName: "base-account" */ '../views/BaseAccount/BaseAccount.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-service',
                name: 'BaseService',
                component: () => import(/* webpackChunkName: "base-service" */ '../views/BaseAccount/BaseService.vue')
            },
            {
                path: '/base-problem',
                name: 'BaseProblem',
                component: () => import(/* webpackChunkName: "base-problem" */ '../views/BaseAccount/BaseProblem.vue')
            },
            {
                path: '/base-rebate',
                name: 'BaseRebate',
                component: () => import(/* webpackChunkName: "base-rebate" */ '../views/BaseAccount/BaseRebate.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-rebate-apply',
                name: 'BaseRebateApply',
                component: () => import(/* webpackChunkName: "base-rebate-apply" */ '../views/BaseAccount/BaseRebateApply.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-wallet',
                name: 'BaseWallet',
                component: () => import(/* webpackChunkName: "base-wallet" */ '../views/BaseAccount/BaseWallet.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-recharge',
                name: 'BaseRecharge',
                component: () => import(/* webpackChunkName: "base-recharge" */ '../views/BaseAccount/BaseRecharge.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-bill',
                name: 'BaseBill',
                component: () => import(/* webpackChunkName: "base-bill" */ '../views/BaseAccount/BaseBill.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-my-trumpet',
                name: 'BaseMyTrumpet',
                component: () => import(/* webpackChunkName: "base-my-trumpet" */ '../views/BaseAccount/BaseMyTrumpet.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-real-name',
                name: 'BaseRealName',
                component: () => import(/* webpackChunkName: "base-real-name" */ '../views/BaseAccount/BaseRealName.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-real-name-modify',
                name: 'BaseRealNameModify',
                component: () => import(/* webpackChunkName: "base-real-name-modify" */ '../views/BaseAccount/BaseRealNameModify.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-indulge',
                name: 'BaseIndulge',
                component: () => import(/* webpackChunkName: "base-indulge" */ '../views/BaseAccount/BaseIndulge.vue'),
                meta: {
                    active: 0
                }
            },
            {
                path: '/base-welfare',
                name: 'BaseWelfare',
                component: () => import(/* webpackChunkName: "base-welfare" */ '../views/BaseWelfare/BaseWelfare.vue'),
                meta: {
                    active: 1
                }
            },
            {
                path: '/base-gift-pack-details',
                name: 'BaseGiftPackDetails',
                component: () => import(/* webpackChunkName: "base-gift-pack-details" */ '../views/BaseWelfare/BaseGiftPackDetails.vue'),
                meta: {
                    active: 1
                }
            },
            {
                path: '/base-activity-details',
                name: 'BaseActivityDetails',
                component: () => import(/* webpackChunkName: "base-activity-details" */ '../views/BaseWelfare/BaseActivityDetails.vue'),
                meta: {
                    active: 1
                }
            },
            {
                path: '/base-open-service',
                name: 'BaseOpenService',
                component: () => import(/* webpackChunkName: "base-open-service" */ '../views/BaseOpenService/BaseOpenService.vue'),
                meta: {
                    active: 2
                }
            },
            {
                path: '/base-message',
                name: 'BaseMessage',
                component: () => import(/* webpackChunkName: "base-open-message" */ '../views/BaseMessage/BaseMessage.vue'),
                meta: {
                    active: 3
                }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
